import React from "react";
import { Link } from "react-scroll";
import styled from "styled-components";
import ClientSlider from "../Elements/ClientSlider";
import ServiceBox from "../Elements/ServiceBox";
import FullButton from "../Buttons/FullButton";
import TeamOne from "../../assets/img/add/newTeam.jpeg";
import TeamTwo from "../../assets/img/add/use12.jpeg";
import TeamThree from "../../assets/img/add/try22.jpg";

const services = [
  {
    icon: "roller",
    title: "Network Engineering & Deployment",
    subtitle: "Radio Network Planning, Traffic back haul - Microwave, Satellite and Fibre Optic backbone network design and deployment. Our experienced team ensures you meet your technical and project deployment targets. Our access deployments cover Radio (2G, 3G, 4G, 5G, WiFi) and Fibre Optics - FTTX",
  },
  {
    icon: "monitor",
    title: "Network Performance & Management",
    subtitle: "Using a wide array of cutting edge tools, our highly qualified engineers test and analyze your network's capabilities and performance. Our network performance optimization services cuts across the telecom network, from the access to the core network to ensure peak Quality of service to your customers.",
  },
  {
    icon: "browser",
    title: "Telecom Consulting & System Integration",
    subtitle: "Having robust experience designing, deploying and managing performance across technologies positions our team to support and advice our clients, helping them to integrate different products from multiple vendors into a seamless and efficient solution.",
  },
  {
    icon: "printer",
    title: "Software & Cloud Solutions",
    subtitle: "Based our deep experience, we deploy industry acclaimed applications or develop custom software applications to support or extend your network capabilities, automate processes and increase the efficiency of your workforce. Whether local or cloud based deployments, our experts stay ready in support to ensure peak performance for your teams.",
  },
  {
    icon: "renew",
    title: "Power Systems & Energies",
    subtitle: "Our renewable energies solutions range from modular Kilowatt to Megawatts capacity solar farms. Designing to meet your specific circumstances, our hybrid solutions allow you to take full advantage of the mix of conventional power to renewable power sources.",
  },
];

export default function Services() {
  return (
    <Wrapper id="services">
      <TrustBand><div className="container"><TrustTitle><span>Trusted across the telecom ecosystem</span><i /></TrustTitle><ClientSlider /></div></TrustBand>
      <ServicesArea>
        <div className="container">
          <SectionHead>
            <div><p className="section-kicker">What we do</p><h2 className="font40 extraBold">Infrastructure expertise.<br />End-to-end execution.</h2></div>
            <p>Our ISO certifications 9001:2015 and 45001:2018 proclaim our strong resolve to work and deliver to world standards with partners.<br />Be sure you are in good hands, with Omnicom in charge</p>
          </SectionHead>
          <ServiceGrid>{services.map((service, index) => <ServiceBox key={service.title} {...service} index={index + 1} />)}</ServiceGrid>
        </div>
      </ServicesArea>
      <TeamSection>
        <TeamGrid className="container">
          <TeamVisual>
            <MainImage src={TeamOne} alt="Omnicom Solutions team" />
            <SmallImage src={TeamTwo} alt="Omnicom engineer at work" />
            <AccentImage src={TeamThree} alt="Omnicom technical team" />
            <TeamMarker><strong>400+</strong><span>workforce</span></TeamMarker>
          </TeamVisual>
          <TeamCopy>
            <p className="section-kicker">A few words about us</p>
            <h2 className="font40 extraBold">The Omnicom team</h2>
            <p>From inception and for all projects, we remain proud of the unique input of each of our qualified and highly motivated executives whose decades of collective experience in the telecom industry is the bedrock of our achievements.</p>
            <ButtonWrap><Link to="contact" smooth offset={-70}><FullButton title="Meet your delivery partner" /></Link></ButtonWrap>
          </TeamCopy>
        </TeamGrid>
      </TeamSection>
    </Wrapper>
  );
}

const Wrapper = styled.section`width: 100%;`;
const TrustBand = styled.div`padding: 30px 0 26px; border-top: 1px solid #e3e7e5; border-bottom: 1px solid #e3e7e5; background: #fff;`;
const TrustTitle = styled.div`display: flex; align-items: center; gap: 16px; color: #777c89; font-size: .68rem; font-weight: 800; letter-spacing: .11em; text-transform: uppercase; i { height: 1px; flex: 1; background: #e3e7e5; }`;
const ServicesArea = styled.div`padding: 110px 0 120px; background: #f6f8f7; @media (max-width: 700px) { padding: 80px 0; }`;
const SectionHead = styled.div`
  display: grid; grid-template-columns: 1.05fr .75fr; gap: 90px; align-items: end; margin-bottom: 52px;
  h2 { color: #17152f; }
  > p { color: #626878; font-size: .9rem; line-height: 1.8; }
  @media (max-width: 780px) { grid-template-columns: 1fr; gap: 20px; }
`;
const ServiceGrid = styled.div`display: grid; grid-template-columns: repeat(6, 1fr); gap: 18px; > * { grid-column: span 2; } > *:nth-child(4) { grid-column: 2 / span 2; } @media (max-width: 960px) { grid-template-columns: repeat(2, 1fr); > * { grid-column: auto !important; } } @media (max-width: 620px) { grid-template-columns: 1fr; }`;
const TeamSection = styled.div`padding: 120px 0; background: #17152f; overflow: hidden; @media (max-width: 800px) { padding: 80px 0; }`;
const TeamGrid = styled.div`display: grid; grid-template-columns: 1.05fr .8fr; gap: 100px; align-items: center; @media (max-width: 900px) { grid-template-columns: 1fr; gap: 70px; }`;
const TeamVisual = styled.div`position: relative; min-height: 560px; @media (max-width: 580px) { min-height: 430px; }`;
const MainImage = styled.img`position: absolute; inset: 0 25% 0 0; width: 75%; height: 100%; object-fit: cover; border-radius: 28px;`;
const SmallImage = styled.img`position: absolute; width: 38%; height: 46%; right: 0; top: 8%; object-fit: cover; border: 8px solid #17152f; border-radius: 22px;`;
const AccentImage = styled.img`position: absolute; width: 42%; height: 35%; right: 2%; bottom: 2%; object-fit: cover; border: 8px solid #17152f; border-radius: 22px;`;
const TeamMarker = styled.div`position: absolute; left: -20px; bottom: 32px; padding: 18px 24px; border-radius: 18px; background: #a8cf45; color: #17152f; box-shadow: 0 20px 40px rgba(0,0,0,.22); strong { display: block; font-size: 1.8rem; line-height: 1; } span { font-size: .7rem; font-weight: 800; text-transform: uppercase; letter-spacing: .1em; } @media (max-width: 1260px) { left: 10px; }`;
const TeamCopy = styled.div`h2 { color: #fff; } > p:last-of-type { margin-top: 24px; color: rgba(255,255,255,.66); font-size: .94rem; line-height: 1.85; } .section-kicker { color: #a8cf45; }`;
const ButtonWrap = styled.div`width: 225px; margin-top: 34px; @media (max-width: 480px) { width: 100%; }`;
